import React from 'react';
import { Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from './rateError.module.css';

function RateError({ event, price = null, maxPrice = null }) {
    const { t } = useTranslation();

    const max = React.useMemo(() => {
        return new Intl.NumberFormat(event?.default_language, { style: 'currency', currency: event.currency }).format(maxPrice);
    }, [maxPrice, event]);

    if (maxPrice) {
        return (
            <div className={css['rate']}>
                <Message mini title={t('ticket.rates.infos.rateErrorTitle')} type="danger" visible>
                    {t('ticket.rates.infos.rateError', { rate: max })}
                </Message>
            </div>
        );
    }
    if (price < 1) {
        return (
            <div className={css['rate']}>
                <Message mini title={t('ticket.rates.infos.rateMinErrorTitle')} type="danger" visible>
                    {t('ticket.rates.infos.rateMinError')}
                </Message>
            </div>
        );
    }
}

export default RateError;
